import { getToken, net, postJson } from '../../admincore'
import { API_URL, BA_URL } from '../../utils/constants'

const { get } = net

export const getTransactions = (companyId, params) => get(`${API_URL}/${companyId}/transactions`, params, getToken())
export const getWallet = (companyId, params) => get(`${API_URL}/${companyId}/balance`, params, getToken())
export const getTransactionTypes = params => get(`${BA_URL}/transaction-type`, params, getToken())
export const getCards = (companyId, params) => get(`${API_URL}/${companyId}/cards`, params, getToken())
export const getSetupIntent = (companyId, params) => get(`${API_URL}/${companyId}/setup-credit-card`, params, getToken())
export const topup = (companyId, params) => postJson(`${API_URL}/${companyId}/topup`, params, getToken())
